import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import pinia from './store'
import router from './router';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@google-pay/button-element';
 

const app = createApp(App);
app.use(ElementPlus);
app.use(router);
app.use(pinia)
app.config.globalProperties.$ELEMENT = {
  size: "large"
}
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mount('#app');
